import { useTranslation } from 'react-i18next';

import { BOARD_COLOR_PRESETS } from '@/entities/board';
import { ColorPicker } from '@/shared/ui';

import styles from './BoardColorPicker.module.css';

interface Props {
  /** The board's own color, `null` = the default. */
  value: string | null;
  /** What "default" looks like for this board (the color the editor starts from). */
  defaultColor: string;
  onChange: (value: string | null) => void;
  /** The board's workspace: its shared palettes come first in the palette library. */
  workspaceId?: string;
}

const OPTIONS = BOARD_COLOR_PRESETS.map((value) => ({ value, label: value }));

/** A board's identification color: presets, the default and any `#rrggbb` (the shared picker). */
export function BoardColorPicker({ value, defaultColor, onChange, workspaceId }: Props) {
  const { t } = useTranslation();
  return (
    <div className={styles.group}>
      <span className={styles.legend}>{t('boards.color')}</span>
      <ColorPicker
        label={t('boards.color')}
        value={value}
        options={OPTIONS}
        noneLabel={t('boards.colorDefault')}
        fallback={defaultColor}
        onPick={onChange}
        {...(workspaceId && { workspaceId })}
      />
      <p className={styles.hint}>{t('boards.colorHint')}</p>
    </div>
  );
}
